import * as React from "react";
import styled from "styled-components";
import { Alert, Button, Col, Row } from "components/bootstrap";
import Icon from "components/common/Icon";
const StyledRow = styled(Row)`
  margin-bottom: 0 !important;
`;
const Container = styled.div(
  ({ margin }) => `
  margin-top: ${margin}px;
  margin-bottom: ${margin}px;
`
);
const ErrorAlert = ({
  children = null,
  onClose = () => void 0,
  bsStyle = "warning",
  marginTopBottom = 15,
  runtimeError = false
}) => {
  const finalBsStyle = runtimeError ? "danger" : bsStyle;
  if (!children) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Container, { margin: marginTopBottom }, /* @__PURE__ */ React.createElement(Alert, { bsStyle: finalBsStyle }, /* @__PURE__ */ React.createElement(StyledRow, null, /* @__PURE__ */ React.createElement(Col, { md: 11 }, runtimeError && /* @__PURE__ */ React.createElement("h4", null, "Runtime Error"), children), /* @__PURE__ */ React.createElement(Col, { md: 1 }, /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", bsStyle: finalBsStyle, className: "pull-right", onClick: () => onClose(void 0) }, /* @__PURE__ */ React.createElement(Icon, { name: "close" }))))));
};
export default ErrorAlert;
